/* CSS */
import "@/js/parts/css";

/* App */
import "@/js/parts/polyfill";
import "@/js/parts/inlined";
import "@/js/parts/hamburger";
import "@/js/parts/lazyloading";
import "@/js/parts/sticky-header";
import "@/js/parts/slideshow";
import "@/js/parts/calendar-ajax";
import "@/js/parts/mailchimp";
import "@/js/parts/checkout/index";

/* Legacy */
import "1dr-utils/helpers/resize.throttle";
import qsa from "1dr-utils/helpers/elsForEach";
import Exposure from "@/js/libs/exposure";
import Stickyfill from "stickyfilljs";

window.qsa = qsa;
let APP = window.APP || {};

window.addEventListener("resize.throttle", () => {
  if (APP.media.matches("mobilemenu")) {
    APP.sidebar.close();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  // const one = 'four';
  // Position:sticky polyfill
  // stickybits( '.sticky', { useStickyClasses: true });
  const elements = document.querySelectorAll(".sticky");
  Stickyfill.add(elements);

  // Apply exposure galleries
  qsa("[data-exposure]", (container) => {
    new Exposure(container);
  });

  // Doesn't work, or isn't needed?

  const o = document.querySelector(".Overlay");
  const n = document.querySelector(".Header");

  APP.lock = () => {
    APP.locked = true;
    o.classList.add("touch-none");
    n.classList.add("touch-none");
  };

  APP.unlock = () => {
    APP.locked = false;
    o.classList.remove("touch-none");
    n.classList.remove("touch-none");
  };
});

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import "@/js/parts/alpine/index";

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}
